import Diacritics from 'diacritic';

export function initUsernameFromName(): void {
    const nameInput = $('#frm-addEdit-name');

    if (!nameInput.length) {
        return;
    }

    nameInput.on('keyup.systemModule', function keyup() {
        const value = Diacritics.clean(String(this.value).toLowerCase());
        const nameRegex = /^[a-zA-Z0-9\-\.\ ]+$/;

        if (value.match(nameRegex) === null) {
            return;
        }

        const action = String($('#frm-addEdit').attr('action') ?? '');

        if (action.indexOf('add') === -1) {
            return;
        }

        const parts = value.split(' ').map((item) => item.trim()).filter(Boolean);
        $('#frm-addEdit-username').val(parts.join('.'));
    });
}
